/*
    TODO(ck): Ideally this map is generated during the publish process to include only the necessary components.
    https://www.notion.so/perspectiveco/Reduce-Funnel-bundle-size-2abf87b6a84480caa9bccad11bb2c50d?source=copy_link
*/

import Accordion from './Accordion';
import Button from './Button';
import Countdown from './Countdown';
import Divider from './Divider';
import Embed from './Embed';
import FormQuestion from './FormQuestion';
import GridColumn from './GridColumn';
import GridRow from './GridRow';
import HeaderButton from './HeaderButton';
import HeaderImage from './HeaderImage';
import Icon from './Icon';
import Image from './Image';
import ImageSlider from './ImageSlider';
import List from './List';
import Loader from './Loader';
import Logos from './Logos';
import MediaQuestion from './MediaQuestion';
import MultipleChoiceQuestion from './MultipleChoiceQuestion';
import PaymentForm from './PaymentForm';
import Reviews from './Reviews';
import TestimonialSlider from './TestimonialSlider';
import Text from './Text';
import TextQuestion from './TextQuestion';
import Video from './Video';
import VideoQuestion from './VideoQuestion';
import Webinar from './Webinar';

import type { ComponentType } from 'svelte';

const mapping: { [componentType: string]: ComponentType } = {
    accordion: Accordion,
    button: Button,
    countdown: Countdown,
    divider: Divider,
    embed: Embed,
    gridColumn: GridColumn,
    gridRow: GridRow,
    headerButton: HeaderButton,
    headerImage: HeaderImage,
    icon: Icon,
    image: Image,
    list: List,
    loader: Loader,
    logos: Logos,
    paymentForm: PaymentForm,
    questionForm: FormQuestion,
    questionMedia: MediaQuestion,
    questionMultipleChoice: MultipleChoiceQuestion,
    questionText: TextQuestion,
    reviews: Reviews,
    sliderImage: ImageSlider,
    sliderTestimonial: TestimonialSlider,
    text: Text,
    video: Video,
    videoQuestion: VideoQuestion,
    webinar: Webinar,
};

export const getBlockComponent = (componentType: string, content: any) => {
    if (componentType === 'media') {
        if (content?.srcType === 'image') {
            return mapping.image;
        } else if (content?.srcType === 'video') {
            return mapping.video;
        } else {
            console.error(`Unknown media srcType: ${content?.srcType}`);

            return undefined;
        }
    }

    const component = mapping[componentType];

    if (!component) {
        console.error(`Unknown component type: ${componentType}`);
    }

    return component;
};
